import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Checkbox,
  Grid,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import LetterX from "../UI/LetterX";
import {
  deleteMedicamento,
  getConveniosScienza,
  getDisponibilidadMedicamentosScienza,
  setearValorEnMedicamento,
} from "../../../actions/empadronamiento/Empadronamiento";
import { EMPADRONAMIENTO_MEDICACION_ESTADOS, TIPO_EMPADRONAMIENTO } from "../../../utils/constants";
import { ModalDisponibilidadMedicamentosScienza } from "../gestionEmpadronamiento/ModalDisponibilidadMedicamentosScienza";
import { CheckCircleIcon } from "@material-ui/data-grid";

const MedicacionInfoAdicionalMedicamento = (props) => {
  const dispatch = useDispatch();
  const disabledProp = props.desdeIngreso || props.disabledEnGestionar;
  const [modalDisponibilidad, setAbrirModalDisponibilidad] = useState(false);
  const { solicitudSeleccionada = {}, conveniosScienzaEmp = [] } = useSelector((state) => state.empadronamiento);

  useEffect(() => {
    dispatch(getConveniosScienza());
  }, []);

  useEffect(() => {
    dispatch(
      setearValorEnMedicamento(
        props.medicamento?.idMedicamento,
        "cantidad",
        Number(props.cantidad)
      )
    );
  }, []);

  const consultarScienza = () => {
    dispatch(getDisponibilidadMedicamentosScienza(props.medicamento.medicamento?.idMonodroga, setAbrirModalDisponibilidad));
    setAbrirModalDisponibilidad(true);
  }
 const NumeroFormateado = (valor) => {
  if (valor == null || isNaN(valor)) return "0,00"; 

  const numeroParseado = parseFloat(
    typeof valor === "string" ? valor.replace(",", ".") : valor
  );

  const numeroFormateado = new Intl.NumberFormat("es-ES", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numeroParseado);

  return numeroFormateado;
};
  return (
    <div style={{ padding: "2em" }}>
      {
        modalDisponibilidad &&
        <ModalDisponibilidadMedicamentosScienza
          open={modalDisponibilidad}
          onClose={() => setAbrirModalDisponibilidad(false)}
          dataMedic={props.medicamento}
          esEmpadronamiento={false}
        />
      }
      <Grid container spacing={2} justify="center">
        <Grid item xs={10} style={{ display: 'flex' }}>
          {!disabledProp && (
            <LetterX
              deleteFunction={() => {
                dispatch(deleteMedicamento(props.medicamento?.idMedicamento));
              }}
              styles={{
                cursor: "pointer",
                position: "relative",
                top: "0.25rem",
                right: "0.2rem",
                marginRight: "0.2rem",
                marginTop: 18
              }}
            />
          )}
          <Typography variant="h6" style={{ flexGrow: 1, fontSize: "1.1rem", marginRight: 20, marginTop: 18, width: "90%" }}>
            {`${props.medicamento?.medicamento?.presentacion} | ${props.medicamento?.medicamento?.laboratorio} | ${props.medicamento?.medicamento?.nombre} | ${props.medicamento?.medicamento?.drogas}`}
          </Typography>
        </Grid>
        <Grid item xs={1} style={{ marginTop: 25, marginLeft: -20 }}>
          {(props.medicamento?.idDisponibilidadSC !== null &&
            props.medicamento?.idDisponibilidadSC !== undefined
          ) && (
              <Tooltip title="Este medicamento ya posee una seleccion de Scienza">
                <CheckCircleIcon style={{ color: 'green', marginRight: 8 }} />
              </Tooltip>
            )}
        </Grid>
        <Grid container spacing={2} style={{ display: 'flex' }}>
          <Grid item xs={2}>
            <TextField
              variant="outlined"
              //type="number"
              fullWidth
              label="Dosis"
              value={props.dosis}
              disabled={disabledProp}
              onChange={(e) => {
                props.setDosis(e.target.value);
                dispatch(
                  setearValorEnMedicamento(
                    props.medicamento?.idMedicamento,
                    "dosis",
                    e.target.value
                  )
                );
              }}
              //error={props.dosis === ""}
              //helperText={props.dosis === "" && "Debe ingresar dosis."}
            />
          </Grid>
          <Grid item xs={2}>
            <TextField
              variant="outlined"
              //type="number"
              fullWidth
              label="Posología"
              value={props.posologia}
              disabled={disabledProp}
              onChange={(e) => {
                props.setPosologia(e.target.value);
                dispatch(
                  setearValorEnMedicamento(
                    props.medicamento?.idMedicamento,
                    "posologia",
                    e.target.value
                  )
                );
              }}
              //error={props.posologia === ""}
              //helperText={props.posologia === "" && "Debe ingresar posología."}
            />
          </Grid>
          <Grid item xs={1}>
            <TextField
              variant="outlined"
              type="number"
              label="Cant. p/presentación"
              value={props.cantidad}
              fullWidth
              disabled={disabledProp}
              onChange={(e) => {
                props.setCantidad(e.target.value);
                dispatch(
                  setearValorEnMedicamento(
                    props.medicamento?.idMedicamento,
                    "cantidad",
                    Number(e.target.value)
                  )
                );
              }}
              error={props.cantidad <= 0}
              helperText={props.cantidad <= 0 && "Debe ser mayor a 0."}
            />
          </Grid>
          {solicitudSeleccionada?.idTipoEmpadronamiento === TIPO_EMPADRONAMIENTO.PACBI
            && <Grid item xs={2} style={{ marginLeft: 20, marginTop: -5 }}>
              <Typography>Convenio</Typography>
              <Select
                fullWidth
                margin="normal"
                label="Convenio"
                name="idConvenioSC"
                value={props.idConvenioSC}
                disabled={disabledProp}
                onChange={(e) => {
                  props.setIdConvenioSC(e.target.value);
                  dispatch(
                    setearValorEnMedicamento(
                      props.medicamento?.idMedicamento,
                      "idConvenioSC",
                      Number(e.target.value)
                    )
                  );
                }}
                validators={["required"]}
                errorMessages={["Convenio es requerido"]}
              >
                {conveniosScienzaEmp.map((convenio) => (
                  <MenuItem
                    key={convenio.idConvenio}
                    value={convenio.idConvenio}
                  >
                    {convenio.descripcion}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          }
          <Grid>
            <Typography>Surge</Typography>
            <Checkbox
              name="surge"
              checked={props.surge}
              disabled={disabledProp}
              onChange={(e) => {
                const checked = e.target.checked;
                props.setSurge(checked);
                dispatch(
                  setearValorEnMedicamento(
                    props.medicamento?.idMedicamento,
                    "surge",
                    checked
                  )
                );
              }}
            /></Grid>
          <Grid item xs={2}>
            <TextField
              variant="outlined"
              type="text"
              label="Precio"
              value={`$ ${NumeroFormateado(props.medicamento?.precioSeleccionado ? props.medicamento?.precioSeleccionado : 0)}`}
              fullWidth
              disabled={true}
            />
          </Grid>
          {solicitudSeleccionada.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_REVISION && (
            <Grid item xs={2}>
              <Button
                variant='contained'
                color="primary"
                style={{ height: '3.5rem' }}
                disabled={props.medicamento?.idItem === null || props.medicamento?.idItem === undefined}
                onClick={() => consultarScienza()}>
                Consultar
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default MedicacionInfoAdicionalMedicamento;
